module.exports = __webpack_public_path__ + "media/images/countryrect/us-47a8b2467d939e28a2c7e2b93251c967.svg";